"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constant = require("../Theme/constant");
var _constant2 = require("./constant");
var _default = {
  PropTypes: {
    theme: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    customProperties: _propTypes.default.object,
    translation: _propTypes.default.shape({
      title: _propTypes.default.string,
      subTitle: _propTypes.default.string,
      contentMsg: _propTypes.default.string,
      thankYouMsg: _propTypes.default.string,
      notificationMsg: _propTypes.default.string,
      notificationLabel: _propTypes.default.string
    }).isRequired,
    state: _propTypes.default.string.isRequired,
    data: _propTypes.default.shape({
      orderId: _propTypes.default.string,
      email: _propTypes.default.string,
      dialingNumber: _propTypes.default.string,
      mobileNumber: _propTypes.default.string,
      name: _propTypes.default.string,
      currency: _propTypes.default.string,
      amount: _propTypes.default.string
    }).isRequired,
    hasNotificationBanner: _propTypes.default.bool,
    notificationBannerType: _propTypes.default.string,
    isMobile: _propTypes.default.bool,
    customIcon: _propTypes.default.string,
    iconAlt: _propTypes.default.string,
    enableLinkTransformation: _propTypes.default.bool
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    customProperties: {},
    translation: _constant2.TRANSLATION,
    state: _constant2.STATE.pending,
    hasNotificationBanner: false,
    notificationBannerType: _constant2.DEFAULT_NOTIFICATION_TYPE,
    isMobile: false,
    customIcon: '',
    iconAlt: _constant2.DEFAULT_ICON_ALT,
    enableLinkTransformation: false
  }
};
exports.default = _default;